import React, { useMemo } from 'react';
import { Link } from 'wouter';
import { Icon } from '../../concepts/resources/Icon';
import { useResolve } from '../Container';
import { PassportModel } from '../PassportModel';
import { AccountHeaderBlock } from '../account/AccountHeaderBlock';
import { AccountModel } from '../account/AccountModel';
import { PlanStateHeaderBlock } from '../account/PlanStateHeaderBlock';
import { Page } from '../common/Page';
import { ManageInformationView } from './ManageInformationView';
import { ManagementTile, ManagementTileMenu } from './ManagementTile';

type TilePredicate = (account: AccountModel, passport: PassportModel) => boolean;

const newTile = (label: string, desc: string, path: string, icon: string, predicate?: TilePredicate) =>
    ({ label, desc, path, icon, predicate: predicate || (() => true) });

const useSections = () =>
    useMemo(() => [
        newTile(
            'People',
            'View and manage people within the organization.',
            '~/manage/people',
            'deqo://icons/i8/people'
        ),
        newTile(
            'Workspaces',
            'View and manage organization workspaces.',
            '~/manage/workspaces',
            'deqo://icons/i8/workspace'
        ),
        newTile(
            'Security & Login',
            'Manage access and login to the organization',
            '~/manage/security',
            'deqo://icons/i8/access'
        ),
        newTile(
            'Billing',
            'View and manage your subscription and plan.',
            '~/manage/billing',
            'deqo://icons/i8/billing',
            (a, p) => !a.settings['billing.custom'] && !!p.verify('ac_billing:write'),
        ),
        newTile(
            'Approvals',
            'View and manage requests from team members.',
            '~/manage/approvals',
            'deqo://icons/i8/pass-fail'
        ),
        // newTile(
        //     'Integrations',
        //     'Connect other applications to your Metro Retro team.',
        //     '~/manage/integrations',
        //     'deqo://icons/i8/connect'
        // ),
        newTile(
            'Danger Zone',
            'You can delete your team in here.',
            '~/manage/danger',
            'deqo://icons/i8/warning'
        ),
    ], []);

const ManagementLink = ({ to, children }: { to: string, children: React.ReactNode }) => {
    if (to.startsWith('http')) {
        return <a href={to} target="_blank" rel="noreferrer">{children}</a>;
    }
    return <Link to={to} >{children}</Link>;
};

export const ManagementRootView = () => {
    const account = useResolve(AccountModel);
    const passport = useResolve(PassportModel);
    const sections = useSections();

    return <>
        <Page.Header>
            <Page.Title>Management</Page.Title>
            <Page.HeaderPush>
                <PlanStateHeaderBlock />
                <AccountHeaderBlock />
            </Page.HeaderPush>
        </Page.Header>
        <Page.Content >
            <ManageInformationView />
            <ManagementTileMenu>
                {sections.filter(x => x.predicate(account, passport)).map(sn =>
                    <ManagementLink key={sn.path} to={sn.path} >
                        <ManagementTile onClick={() => { }}>
                            <ManagementTile.Border>
                                <ManagementTile.Icon>
                                    <Icon size={sn.icon ? 3 : 4} src={sn.icon ?? 'deqo://icons/dash/folder-grid-icon'} />
                                </ManagementTile.Icon>
                                <ManagementTile.Info>
                                    <ManagementTile.Label>{sn.label}</ManagementTile.Label>
                                    <ManagementTile.Desc>{sn.desc}</ManagementTile.Desc>
                                </ManagementTile.Info>
                            </ManagementTile.Border>
                        </ManagementTile>
                    </ManagementLink>
                )}
            </ManagementTileMenu>
        </Page.Content>
    </>;
}
    ;
